module.exports = __webpack_public_path__ + "site_static/img/channel3.71507f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channel3.png
// module id = oXQb
// module chunks = 0